import { useState, useEffect } from "react";
import liff from "@line/liff";
import ContentCard from "../components/ContentCard";
import axios from "axios";
import InfiniteScroll from "react-infinite-scroll-component";
import Loading from "../components/Loading";

export interface PhotoProps {
  id: string;
  alt_description: string;
  urls: {
    regular: string;
  };
  user: {
    name: string;
    profile_image: {
      small: string;
    };
  };
  likes: number;
  promoted_at: number;
  description: string;
}

const HomePage = () => {
  // const [displayName, setDisplayName] = useState("");
  // const [statusMessage, setStatusMessage] = useState("");

  const [photos, setPhotos] = useState<PhotoProps[]>([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  const initializeLiff = async () => {
    // await liff.init({ liffId: process.env.REACT_APP_LIFF_ID! });
    // if (liff.isLoggedIn()) {
      // const profile = await liff.getProfile();
      // console.log(profile);
      // setDisplayName(profile.displayName);
      // setStatusMessage(profile.statusMessage);
    // } else {
      // liff.login();
    // }
  };

  const fetchPhotos = async () => {
    try {
      const response = await axios.get(
        `https://api.unsplash.com/photos?page=${page}`,
        {
          headers: {
            Authorization:
              "Client-ID " + process.env.REACT_APP_UNSPLASH_ACCESS_KEY,
          },
        }
      );
      setPhotos((prevPhotos) => [...prevPhotos, ...response.data]);
      setPage((prevPage) => prevPage + 1);
      setHasMore(response.data.length > page);
      // console.log(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    initializeLiff();
    fetchPhotos();
    document.title = "Home";
  }, []);

  return (
    <InfiniteScroll
      dataLength={photos.length}
      next={fetchPhotos}
      hasMore={hasMore}
      loader={<Loading />}
    >
      <div className="container mx-auto mt-[64px]">
        {photos.map((photo) => (
          <div className="mb-3" key={photo.id}>
            <ContentCard
              title={photo.alt_description}
              description={photo.description}
              image={photo.urls.regular}
              avatar={photo.user.profile_image.small}
              displayName={photo.user.name}
              likes={photo.likes}
              createdAt={photo.promoted_at}
            />
          </div>
        ))}
      </div>
    </InfiniteScroll>
  );
};

export default HomePage;
